import { render, staticRenderFns } from "./KokuList.vue?vue&type=template&id=28719791&"
import script from "./KokuList.vue?vue&type=script&lang=js&"
export * from "./KokuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports